import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");

    if (!sid) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      const res = await exchangeSession(sid);
      // Clear the hash to avoid replays
      window.history.replaceState(null, "", window.location.pathname);
      if (!res.ok) {
        navigate("/?auth_error=1", { replace: true });
        return;
      }
      let intendedRoute = null;
      try {
        intendedRoute = sessionStorage.getItem("miresco_intended_route");
        sessionStorage.removeItem("miresco_intended_route");
      } catch (e) { /* silent — sessionStorage may be unavailable in private mode */ }
      if (res.needs_role) {
        navigate("/welcome", { replace: true, state: { user: res.user, intendedRoute } });
      } else {
        navigate(intendedRoute || "/dashboard", { replace: true, state: { user: res.user } });
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#C8102E] border-t-transparent animate-spin mx-auto mb-4" />
        <div className="font-mono text-sm text-zinc-600">Signing you in…</div>
      </div>
    </div>
  );
}
